import moment from 'moment';

export default class DateHelper {

	static momentFromUsaString(string) {
		return moment(string, 'MM/DD/YYYY');
	}

	static getDaysForMonth(momentMonth) {
		const dayList = [];
		const start = moment(`${momentMonth.year()}-${momentMonth.month() + 1}-1`);
		for(let end = moment(start).add(1, 'month'); start.isBefore(end); start.add(1, 'day')) {
			dayList.push(start.clone());
		}
		return dayList;
	}

	static convertTo24HourTime(timeString) {
		const minutes = Number(timeString.match(/:(\d+)/)[1]);
		const AMPM = timeString.match(/\s(.*)$/)[1];
		let hours = Number(timeString.match(/^(\d+)/)[1]);
		if(AMPM === 'PM' && hours < 12) {
			hours = hours + 12;

		}
		if(AMPM === 'AM' && hours === 12) {
			hours = hours - 12;
		}
		return {
			hours,
			minutes
		};
	}

	static yearMonthSerialize(date) {
		return `${date.year()}-${date.month()}`;
	}

	static momentFromDateParts(year, month, day, hour, minutes, seconds) {
		console.log(year, month, day, hour, minutes, seconds);
		const theMoment = moment();
		theMoment.year(year);
		theMoment.month(month - 1);
		theMoment.date(day);
		if(hour) {
			theMoment.hour(hour);
		}
		if(minutes) {
			theMoment.minutes(minutes);
		}
		if(seconds) {
			theMoment.seconds(seconds);
		}
		return theMoment;
	}
}